import { Button } from "@/components/catalyst/Button";
import { Heading } from "@/components/catalyst/Heading";
import { Text } from "@/components/catalyst/Text";

interface PartnershipsSectionProps {
	onOpenPartnersDialog: () => void;
}

export function PartnershipsSection({
	onOpenPartnersDialog,
}: PartnershipsSectionProps) {
	return (
		<div className="col-span-full flex items-center justify-between">
			<div>
				<Heading level={4}>Partnerships</Heading>
				<Text>Manage your app partners and network settings.</Text>
			</div>
			<Button outline onClick={onOpenPartnersDialog}>
				Manage Partners
			</Button>
		</div>
	);
}
